import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent  {
  @Input() logo = '';
  @Input() logoName = '';
  @Input() logoLink = '';

  get svgLogo() {
    if (this.logo.indexOf('/') == -1) {
      return this.logo;
    }
    return '';
  }

  get notSVGLogo() {
    if (this.logo.indexOf('/') > -1) {
      return this.logo;
    }
    return '';
  }
}
